// Golf 4 (Arabisch): Jouw gegevens (0036), weergave per tablet, wijzigingen weggooien,
// verwachte dagen, modules, werklijst en Ramadan op het bord. Zelfde vorm als de nl-bestanden; de
// stukken worden in app.ar.ts, profileApp.ar.ts, modulesApp.ar.ts, werklijstApp.ar.ts en
// weatherPrayer.ar.ts ingehaakt. AMUMIN Beheer (beheerApp) blijft nl/en: alleen de oprichter.
export const appPrivacyRightsAr = {
    title: 'بياناتك',
    intro: 'نزِّل كل شيء، أو أخرِج أحدًا من العائلة، أو احذف لوحة العائلة. إنها بياناتكم.',
    entry: 'بياناتك',
    entryBody: 'نزِّل كل شيء، أخرِج أحدًا من العائلة، احذف لوحة العائلة.',
    exportTitle: 'تنزيل كل شيء',
    exportBody: 'ملف ZIP واحد فيه كل ما يخص عائلتكم: الأفراد، الأجندة، المهام، الطعام، الرسائل، معلومات عن الصور، والاختيارات في «ما يناسب عائلتنا». ومعه ملخص سهل القراءة.',
    exportOwnerOnly: 'مالك لوحة العائلة وحده يمكنه تنزيل كل شيء.',
    exportStart: 'تجهيز التنزيل',
    exportPending: 'نحن نجهّز الملف. يستغرق ذلك عادةً أقل من دقيقة.',
    exportReady: 'جاهز · {size} · يمكن تنزيله حتى {time}',
    exportOnce: 'يمكنك تنزيل الملف مرة واحدة. بعد ذلك نحذفه.',
    exportDownload: 'تنزيل',
    exportDownloaded: 'نُزِّل في {time}',
    exportExpired: 'انتهت صلاحيته في {time}',
    exportFailed: 'تعذّر إنشاء الملف. حاول مرة أخرى.',
    exportAgain: 'تجهيز من جديد',
    exportMailed: 'يتلقى جميع الوالدين بريدًا بأن التنزيل جاهز.',
    exportStarted: 'نحن نجهّز الملف',
    exportSaved: 'الملف في مجلد التنزيلات',
    mineTitle: 'بياناتك أنت فقط',
    mineBody: 'بياناتك الخاصة وملف العائلة الذي ينطبق عليك، كملف (JSON).',
    mineButton: 'تنزيل بياناتي',
    removeTitle: 'إخراج أحد من العائلة',
    removeBody: 'مثلًا طفل غادر البيت أو شريك سابق. يتم ذلك في «العائلة»: افتح الشخص واختر «إخراج من العائلة».',
    removeToMembers: 'إلى العائلة',
    removeButton: 'إخراج من العائلة',
    removeConfirmTitle: 'إخراج {name} من العائلة؟',
    removeConfirmNow: 'يختفي {name} فورًا من التطبيق ومن اللوحة. إذا كان لدى {name} تسجيل دخول خاص، فلن يعمل بعد الآن لهذه العائلة.',
    removeConfirmLater: 'يمكنك التراجع خلال 7 أيام. بعد ذلك نجعل {name} مجهول الهوية: يصبح الاسم «فرد سابق من العائلة»، وتُحذف الصورة وتاريخ الميلاد والبيانات الخاصة (الدين، الصحة، المدرسة)، وكذلك المواعيد والمهام القادمة. ما حدث سابقًا يبقى بلا اسم.',
    removeConfirmProfile: 'الاختيارات الشخصية في «ما يناسب عائلتنا» وفي الطقس تُحذف فورًا ولا تعود عند التراجع.',
    removeConfirmButton: 'إخراج من العائلة',
    removeButtonHouse: 'إخراج من المنزل',
    removeConfirmTitleHouse: 'إخراج {name} من المنزل؟',
    removeConfirmNowHouse: 'يختفي {name} فورًا من التطبيق واللوحة. إذا كان لدى {name} تسجيل دخول خاص، فلن يعمل بعد الآن لهذا المنزل.',
    removeConfirmLaterHouse: 'يمكنك التراجع عن ذلك خلال 7 أيام. بعد ذلك نجعل {name} مجهول الهوية: يصبح الاسم “{former}”، وتُحذف الصورة والبيانات الشخصية، وكذلك المواعيد والمهام المستقبلية. ما حدث بالفعل (ومنه المصاريف) يبقى بلا اسم.',
    removeConfirmProfileHouse: 'تُحذف اختيارات {name} الخاصة (مثل الطعام والطقس) فورًا ولا تعود عند التراجع.',
    removeConfirmButtonHouse: 'إخراج من المنزل',
    removeConfirmAnywayHouse: 'إخراج من المنزل على أي حال',
    removedHouse: 'تم إخراج {name} من المنزل',
    removeConfirmLinks: 'روابط التقويم التي أنشأها {name} (Google أو Outlook أو Apple) تتوقف فورًا.',
    removeConfirmDevices: 'ربط {name} هذه الأجهزة اللوحية. تبقى تعمل حتى تفك ربطها:',
    removeUnpairDevice: 'فك ربط الجهاز اللوحي',
    removeDevicePaired: 'رُبط في {date}',
    removeDeviceUnpaired: 'تم فك ربط {name}',
    removed: 'تم إخراج {name} من العائلة',
    removedListTitle: 'أُخرِجوا من العائلة',
    removedUntil: 'يمكن التراجع حتى {time}',
    removedHadLogin: 'أُلغي تسجيل الدخول',
    undo: 'تراجع',
    undone: 'عاد {name} إلى العائلة',
    undoneNoLogin: 'عاد {name} إلى العائلة. تعذّر استعادة تسجيل الدخول؛ أرسل دعوة من جديد.',
    errorIsOwner: 'لا يمكن إخراج المالك من العائلة.',
    errorIsSelf: 'لا يمكنك إخراج نفسك من العائلة.',
    errorNeedsOwner: 'المالك وحده يمكنه إخراج أحد الوالدين الآخرين من العائلة.',
    errorWindowClosed: 'انقضت الأيام السبعة؛ لم يعد التراجع ممكنًا.',
    errorAlreadyRemoved: 'هذا الشخص أُخرِج من العائلة بالفعل.',
    errorDeletionUnavailable: 'الحذف غير ممكن الآن. لم تتم جدولة أي شيء؛ حاول لاحقًا أو راسلنا.',
    errorConfirmName: 'الاسم غير مطابق. اكتب اسم لوحة عائلتك كما هو تمامًا.',
    errorExportGone: 'هذا الملف لم يعد موجودًا. جهّز تنزيلًا جديدًا.',
    zipHint: 'كل شيء في ملف ZIP واحد مع ملخص سهل القراءة:',
    deleteTitle: 'حذف لوحة العائلة',
    deleteBody: 'يُمحى كل ما يخص عائلتكم: الأجندة، المهام، الطعام، الرسائل، الصور والإعدادات. لديك 30 يومًا للتفكير.',
    deleteOwnerOnly: 'المالك وحده يمكنه حذف لوحة العائلة.',
    deleteButton: 'حذف لوحة العائلة…',
    deleteConfirmTitle: 'حذف لوحة العائلة؟',
    deletePoints: [
        'بعد 30 يومًا نمحو كل ما يخص {household}. ولا يمكن استعادته بعد ذلك.',
        'حتى ذلك اليوم يمكنك إيقافه باختيار «عدم الحذف».',
        'حتى ذلك الحين تعرض الأجهزة اللوحية رسالة هادئة ثم تتوقف.',
        'يتلقى جميع الوالدين بريدًا، الآن وعندما يُمحى كل شيء.',
    ],
    deleteExportFirst: 'تنزيل كل شيء أولًا؟',
    deleteExportFirstBody: 'احتفظ بنسخة قبل الحذف. يمكن ذلك لاحقًا أيضًا، حتى اليوم نفسه.',
    deleteTypeName: 'اكتب اسم لوحة عائلتك للتأكيد',
    deleteTypeNameHint: 'تمامًا: {household}',
    deleteConfirmButton: 'الحذف بعد 30 يومًا',
    deleteScheduled: 'ستُحذف لوحة العائلة في {date}',
    deleteScheduledBody: 'حتى ذلك اليوم يعمل كل شيء كالمعتاد. بعد ذلك نمحو كل شيء ويتلقى جميع الوالدين بريدًا.',
    deleteScheduledByAdmin: 'خطّطت له AMUMIN بناءً على طلبكم.',
    cancelDelete: 'عدم الحذف',
    cancelled: 'لوحة العائلة باقية',
    banner: 'ستُحذف لوحة العائلة هذه في {date}.',
    bannerOwner: 'عدم الحذف',
    bannerOthers: 'المالك وحده يمكنه إيقاف ذلك.',
    bannerMore: 'معرفة المزيد',
    formerMember: 'فرد سابق من العائلة',
    formerMemberShared: 'شريك سكن سابق',
    formerMemberResident: 'ساكن سابق',
    summary: {
        title: 'بيانات {household}',
        intro: 'هذه كل بيانات لوحة عائلتكم في {date}، كما تحفظها AMUMIN. كل جزء في ملف JSON خاص به؛ يمكنك فتحه بمحرر نصوص أو استيراده في برنامج آخر.',
        fileHeader: 'الملف',
        whatHeader: 'المحتوى',
        countHeader: 'الأسطر',
        membersTitle: 'الأفراد',
        memberFormer: 'فرد سابق من العائلة',
        memberArchived: 'لم يعد نشطًا',
        notIncludedTitle: 'ما ليس فيه',
        notIncluded: 'الأسرار (كلمات المرور، الرموز السرية، رموز الربط وبيانات دخول الأجهزة اللوحية)، والسجلات التقنية، والنسخ المؤقتة من ردود الخدمات الأخرى. الصور والتسجيلات نفسها ليست فيه؛ فقط متى التُقطت وحجمها.',
        rightsTitle: 'حقوقكم',
        rights: 'يمكنك تصحيح البيانات في التطبيق نفسه، أو إخراج أحد من العائلة، أو حذف لوحة العائلة كلها من الإعدادات › بياناتك. أسئلة أو شكوى؟ تواصل مع AMUMIN (انظر بيان الخصوصية في التطبيق)؛ ويمكنك أيضًا تقديم شكوى إلى هيئة حماية البيانات الهولندية (Autoriteit Persoonsgegevens).',
        accountTitle: 'حسابك',
        accountBody: 'البريد الإلكتروني الذي تسجّل به الدخول ومتى أُنشئ حسابك (account.json).',
        domains: {
            household: {
                title: 'العائلة والأجهزة اللوحية',
                body: 'لوحة العائلة مع نوع الأسرة، الأفراد، تسجيلات الدخول (دون كلمات المرور) واختياراتهم للشاشة، الغرف، الأجهزة اللوحية، الدعوات والموقع التقريبي.',
            },
            profile: {
                title: 'ما يناسب عائلتنا',
                body: 'المطبخ، الدين، الطعام والأيام الخاصة، مع كل الموافقات (بما فيها المسحوبة).',
            },
            calendar: {
                title: 'الأجندة',
                body: 'المواعيد، التكرارات، من يشارك، التوصيلات، التذكيرات والأجندات المرتبطة.',
            },
            tasks: {
                title: 'المهام والمكافآت',
                body: 'المهام، من أنجزها، النقاط، المكافآت والطلبات.',
            },
            food: {
                title: 'الطعام',
                body: 'المشتريات، الوصفات، قائمة الأسبوع والمخزون.',
            },
            // Golf 8 (0049): Kosten delen.
            costs: {
                title: 'تقاسم المصاريف',
                body: 'المصاريف وتقسيمها والتسويات والفترات المغلقة للبيت.',
            },
            family: {
                title: 'العائلة والرسائل',
                body: 'قوائم الأمنيات، جهات الاتصال، العائلات المرتبطة، المحادثات والرسائل.',
            },
            rooms: {
                title: 'الغرف والتنظيف',
                body: 'من ينام في أي غرفة، الأعمال المنزلية، جدول المناوبة (الغياب والتبديل)، سجل التنظيف وأقفال الأطفال (دون الرمز).',
            },
            media: {
                title: 'الصور والتسجيلات',
                body: 'معلومات عن الصور والتسجيلات: النوع والحجم والتاريخ.',
            },
            care: {
                title: 'التحقق ودائرة العائلة',
                body: 'متى نُقر على «كل شيء بخير»، والتنبيهات ومن تلقاها، وفترات الإيقاف، والدائرة وصلاحياتها، وموافقات الشخص المسن.',
            },
            weather_prayer: {
                title: 'الطقس ومواقيت الصلاة',
                body: 'إعدادات نصيحة الطقس ومواقيت الصلاة.',
            },
            growth: {
                title: 'النمو',
                body: 'الطول والوزن مع الموافقات، إن كنتم تستخدمونه.',
            },
            school: {
                title: 'المدرسة',
                body: 'المواد والنتائج، إن كنتم تستخدمونها.',
            },
            security: {
                title: 'الأمان',
                body: 'الشبكات الموثوقة، تنبيهات الأمان وسجل التدقيق (من فعل ماذا، دون محتوى).',
            },
            privacy: {
                title: 'طلبات الخصوصية',
                body: 'تنزيلات مثل هذا، ومن أُخرِج من العائلة، وحذف مخطَّط له.',
            },
            billing: {
                title: 'الاشتراك والفواتير',
                body: 'اشتراكك وشهرك التجريبي، وما تغيّر (الإلغاء، الدفع) والفواتير. نحتفظ بالفواتير 7 سنوات، حتى بعد الحذف (التزام قانوني).',
            },
            // 0068: Gezond op gewicht (persoonlijk).
            kompas: {
                title: 'وزن صحي',
                body: 'بياناتك أنت فقط: موافقتك، ملفك وهدفك، ما أكلته، الماء، الحركة، الأوزان وبطاقتك على اللوحة. تُحفظ في مساحتك الخاصة؛ لا يراها أحد غيرك.',
            },
            // 0069: Geldzaken.
            money: {
                title: 'الشؤون المالية',
                body: 'مساحاتك ومعاملاتك (مع إخفاء رقم IBAN للآخرين) وقواعدك وأهدافك وممتلكاتك. فقط في تنزيل مساحتك الخاصة.',
            },
        },
    },
};
export const appEditorG4Ar = {
    discardTitle: 'تجاهل التغييرات؟',
    discardBody: 'سيضيع ما أدخلته.',
    discardKeep: 'متابعة التعديل',
    discardConfirm: 'تجاهل',
};
export const appDevicesG4Ar = {
    layout: 'طريقة العرض',
    layoutAuto: 'تلقائي',
    layoutAutoHint: 'يتكيّف مع الشاشة تلقائيًا، حتى عند تدوير الجهاز: مضغوط على شاشة صغيرة، وعريض على شاشة كبيرة أفقية، وكبير في غير ذلك.',
    layoutLarge: 'كبير',
    layoutLargeHint: 'اللوحة كلها جنبًا إلى جنب، كما على iPad غرفة الجلوس.',
    layoutCompact: 'مضغوط',
    layoutCompactHint: 'أعمدة أقل وكل شيء أكبر، مقروء من مسافة مترين. لجهاز لوحي صغير أو iPad mini.',
    layoutShown: 'طريقة العرض: {layout}',
    // Tablet-breed: breed (en automatisch op elk scherm).
    layoutWide: 'عريض',
    layoutWideHint: 'التقويم والمهام وعمود «اليوم» جنبًا إلى جنب. لجهاز لوحي بحجم 10 إنش أو أكبر معلّق أفقيًا.',
};
export const appProfileDaysG4Ar = {
    expectedTag: 'متوقَّع',
    sheet: {
        expected: 'هذا اليوم لم يُحدَّد بعد.',
        when: 'يقع في {dates}.',
        confirm: 'تأكيد اليوم',
        confirmHint: 'أكِّده أو انقله في «ما يناسب عائلتنا»، الأيام الخاصة.',
    },
};
export const appModulesG4Ar = {
    offBecause: 'متوقف ({names} متوقف)',
    exampleA: 'مريم',
    exampleB: 'يوسف',
    holidaysIslamic: 'وأيضًا عيد الفطر وعيد الأضحى حسب تقليدكم.',
};
export const appWerklijstG4Ar = {
    progressRegion: 'التقدّم',
};
export const prayerRamadanAr = {
    word: {
        turkish: 'رمضان',
        arabic: 'رمضان',
    },
    imsak: {
        turkish: 'الإمساك',
        arabic: 'الإمساك',
    },
    sabah: {
        turkish: 'الصبح',
        arabic: 'الفجر',
    },
    iftar: {
        turkish: 'الإفطار',
        arabic: 'الإفطار',
    },
    day: '{word} · اليوم {n}',
    last: '{word} · اليوم الأخير',
    countdown: 'بقي {n} د',
    now: 'حان وقت {iftar}',
    tomorrow: 'غدًا',
    eve: 'يبدأ {word} غدًا',
};
//# sourceMappingURL=golf4App.ar.js.map